import { createSelector } from "reselect"

export const selectCompanies = state => state.companies

export const selectCompaniesAsArray = createSelector(
    selectCompanies, companies => Object.values(companies)
)

export const selectCompanyId = (state, ownProps) => ownProps.match.params.id

export const selectCompany = createSelector(
    selectCompaniesAsArray, selectCompanyId,
    (companies, id) => {
        return companies.find(company => company.id.toString() === id)
    }
)


// WEBPACK FOOTER //
// src/data/companies/selectors.js